<div class="log-details">
  <article *ngIf="entity.id">
    <div class="d-flex justify-content-between align-items-center w-100">
      <h4>Log <small>#{{entity.id}}</small></h4>
      <span>{{entity.created}} <em
        [innerHTML]="getUsernameElement(entity)"></em> on [{{entity.userIp === '::1' ? 'localhost' : entity.userIp}}
        ]</span>
    </div>
    <div class="panel panel-default mt-2">
      <div class="panel-body"><span [innerHTML]="getLogLabel(entity)"></span><span
        class="pl-1">{{entity.message}}</span></div>
    </div>
    <dl>
      <dt>Service</dt>
      <dd>
        <pre [innerHTML]="entity.service"></pre>
      </dd>
      <dt>Data</dt>
      <dd>
        <pre [innerText]="getFormattedData(entity.data)"></pre>
      </dd>
      <dt>User-Agent</dt>
      <dd>
        <pre [innerText]="entity.userAgent"></pre>
      </dd>
    </dl>
  </article>
  <div class="row no-gutters my-4">
    <nav class="col-12 my-1 text-end">
      <button type="button" class="btn btn-secondary me-2" (click)="back()">Back to logs</button>
    </nav>
  </div>
</div>
